import React, { useEffect, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import {
	colors,
} from '@mui/material';
import { Tile } from 'powerbi-client';
import ModalDialog from '../../../../../../../../../../components/ModalDialog/ModalDialog.js';
import Layer3Form from './components/Layer3Dialog/Layer3Form';
import { SetFormState, GetLayer3, GetLayer3Kpis, GetLayer3DriveTest } from '../../../../../../../../actions/VoiceActions';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 960,
	},
	header: {
		padding: theme.spacing(3),
		maxWidth: 720,
		margin: '0 auto',
	},
	content: {
		padding: theme.spacing(0, 2),
		maxWidth: 720,
		margin: '0 auto',
	},
	helperText: {
		textAlign: 'right',
		marginRight: 0,
	},
	author: {
		margin: theme.spacing(4, 0),
		display: 'flex',
	},
	avatar: {
		marginRight: theme.spacing(2),
	},
	actions: {
		backgroundColor: colors.grey[100],
		padding: theme.spacing(2),
		display: 'flex',
		alignContent: 'right',
	},
	applyButton: {
		color: theme.palette.white,
		backgroundColor: colors.green[600],
		'&:hover': {
			backgroundColor: colors.green[900],
		},
	},
}));

const Layer3Dialog = (props) => {
	const { author, open, onClose, onApply, className, ...rest } = props;
	const dispatch = useDispatch();
	const setFormState = formState => dispatch(SetFormState(formState));
	const formState = useSelector((state) => state.voiceReducer.formState);
	const tableId = useSelector((state) => state.voiceReducer.tableId);
	const filenameMoc = useSelector((state) => state.voiceReducer.filenameMoc);
	const filenameMtc = useSelector((state) => state.voiceReducer.filenameMtc);
	const failureSide = useSelector((state) => state.voiceReducer.failureSide);
	const failureType = useSelector((state) => state.voiceReducer.failureType);
	const initialTimestamp = useSelector((state) => state.voiceReducer.initialTimestamp);
	const layer3 = useSelector((state) => state.voiceReducer.layer3);
	const layer3Kpis = useSelector((state) => state.voiceReducer.layer3Kpis);
	// const formState = useSelector((state) => state.voiceReducer.formState);

	const userId = useSelector(state => state.session.user.id);

	useEffect(() => {
		dispatch(GetLayer3(formState.values.filenameMoc, formState.values.filenameMtc, formState.values.initialTimestamp, userId));
		dispatch(GetLayer3Kpis(formState.values.filenameMoc, formState.values.filenameMtc, formState.values.failureSide, formState.values.initialTimestamp));
		dispatch(GetLayer3DriveTest(userId, 'rsrp', formState.values.filenameMoc, formState.values.filenameMtc, formState.values.failureSide, formState.values.initialTimestamp));
	}, []);

	const title = `Failure ${formState.values.failureType} from ${formState.values.failureSide} at ${formState.values.initialTimestamp}`;

	return (
		<ModalDialog
			maxWidth=""
			onClose={onClose}
			open={open}
			title={title}
			// confirmLabel="Save"
			cancelLabel="Close"
			// onConfirmClicked={_onConfirmClick}
			hasConfirm={false}
		>
			{/* onConfirmClicked={_onConfirmClick}> */}
			{/* <Layer3Form isEdit={openAddEditUserDialogId} roles={roles} operators={operators} projects={operatorProjects} /> */}
			{<Layer3Form />}
		</ModalDialog>
	);
};

Layer3Dialog.propTypes = {
	author: PropTypes.object.isRequired,
	className: PropTypes.string,
	onApply: PropTypes.func,
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default Layer3Dialog;
